/* eslint-disable  */

import React, { useEffect, useState, useCallback } from 'react'
import { Button, Divider, Grid, TextField, Typography } from '@material-ui/core'
import { KeyboardDatePicker } from '@material-ui/pickers'
import { useProperties } from '~/properties'
import { Autocomplete } from '@mui/material'
import { useGetDynamicUnitTypes } from '~/unit-types'
import { api } from '#/apis';
import { useCreateWhip } from '~/whips'
import { date } from 'joi'

const WhipsCreateForm = props => {
	const { setModalOpen } = props
	const [formValues, setFormValues] = useState()
	const [enabled, setEnabled] = useState(false)

	const {
		data: properties,
		isLoading: loadingProperties,
		isError: errorLoadingProperties,
	} = useProperties()

	const { mutate: createWhip } = useCreateWhip()

	const {
		mutate: getUnitTypes,
		data: units,
		isLoading: loadingUnits,
	} = useGetDynamicUnitTypes()

	const fetchUnitTypes = useCallback(async () => {
		const propId = formValues?.prop_name?.id

		getUnitTypes({
			propertyId: propId,
		})
	}, [properties, getUnitTypes, formValues])

	useEffect(() => {
		if (formValues?.prop_name) {
			fetchUnitTypes()
		}
		return () => {}
	}, [formValues])


	const validateForm = () => {

		if (
			formValues?.id &&
			formValues?.prop_name &&
			formValues?.unit_number &&
			formValues?.status &&
			formValues?.applicants &&
			formValues?.comments
		) {
			setEnabled(true)
		}
		else {
			setEnabled(false)
		}
	}

	const handleChange = e => {
		const { name, value } = e.target

		setFormValues(prevState => ({
			...prevState,
			[name]: value,
		}))

		validateForm()
	}

	const handleSubmit = async event => {
		
		createWhip(formValues)
	}


	return (
		<form 
			style={{
				marginTop: '20px',
				marginBottom: '20px',
			}}
			xs={6}
		>
			<div>
				<Typography variant='h5' children='New Whip' />
			</div>

			<Divider style={{ marginTop: '5px', marginBottom: '20px' }} />

			<TextField
				name='id'
				value={formValues?.id || ''}
				label='ID'
				fullWidth
				onChange={handleChange}
			/>

			<Autocomplete
				name='prop_name'
				loading={loadingProperties}
				fullWidth
				options={properties || []}
				getOptionLabel={opt => opt.name || ''}
				renderInput={params => (
					<TextField {...params} required label='Property' />
				)}
				value={formValues?.prop_name}
				onChange={(e, value) => {
					handleChange({
						target: {
							name: 'prop_name',
							value: value || '',
						},
					})
				}}
			/>

			<Autocomplete
				name='unit_number'
				fullWidth
				disabled={!formValues?.prop_name}
				options={units?.rows || []}
				loading={loadingUnits}
				getOptionLabel={opt => opt.unit_number|| ''}
				renderInput={params => (
					<TextField {...params} required label='Unit Number' />
				)}
				value={formValues?.unit_number}
				onChange={(e, value) => {
					handleChange({
						target: {
							name: 'unit_number',
							value: value || '',
						},
					})
				}}
			/>

			<Autocomplete
				name='status'
				fullWidth
				options={['pending', 'verified', 'rejected', 'resident_opt_out']}
				renderInput={params => (
					<TextField {...params} required label='Status' />
				)}
				value={formValues?.status || []}
				onChange={(e, value) => {
					handleChange({
						target: {
							name: 'status',
							value: value || '',
						},
					})
				}}
			/>

			<TextField
				name='applicants'
				value={formValues?.applicants || ''}
				label='Applicants'
				fullWidth
				onChange={handleChange}
			/>

			<TextField
				name='comments'
				value={formValues?.comments || ''}
				label='Comments'
				fullWidth
				onChange={handleChange}
			/>

			<Grid
				container
				justifyContent='flex-end'
				spacing={3}
				style={{ marginTop: '10px' }}
			>
				<Grid item>
					<Button
						onClick={() => {
							setModalOpen(false)
						}}
						children='Cancel'
						variant='contained'
					/>
				</Grid>
				<Grid item>
					<Button
						variant='contained'
						color='primary'
						type='submit'
						disabled={!enabled}
						onClick={handleSubmit}
						children='Submit'
					/>
				</Grid>
			</Grid>
		</form>
	)
}

export default WhipsCreateForm
